import { Injectable } from '@angular/core';
import { IndexedDbService } from './indexed-db.service';
import { Table } from 'dexie';

@Injectable({
  providedIn: 'root',
})
export class IndexedDBHelper {
  constructor(private dbService: IndexedDbService) {}

  async isTableExist(tableName: string): Promise<boolean> {
    return await this.dbService.isTableExist(tableName);
  }

  async createTable(projectId: string): Promise<void> {
    await this.dbService.createTableForProject(projectId);
  }

  async saveData<T>(projectId: string, fetchData: () => Promise<T>,transformData?: (data: T) => T): Promise<void> {
    try {
      const table = await this.dbService.getTable<T>("individual_"+projectId);
      const data = await fetchData();
      if (data) {
        const finalData = transformData ? transformData(data) : data;
        if (Array.isArray(finalData)) {
          await table.bulkAdd(finalData);
        } else {
          await table.add(finalData);
        }        
      }
    } catch (error) {
      console.error(`Error saving data to table`, error);
    }
  }

  async deleteById<T>(tableName: string, id:number):Promise<void>{
    try {
      const table = await this.dbService.getTable<T>(tableName);
      const dataById = await table.get(id);
      if(dataById){
        await table.delete(id);
      }else{
        console.warn(`Table ${tableName} does not contain any record for ${id}. Skipping data deletion.`);
      }
    } catch (error) {
      console.error(`Error deleting data from ${tableName} for ${id}`, error);
    }
  }

  async getAll<T>(tableName: string): Promise<T[]> {
    try {
      const table = this.dbService.getTable<T>(tableName);
      return await (await table).toArray();
    } catch (error) {
      console.error(`Error fetching all data from table ${tableName}:`, error);
      throw error;
    }
  }

  async getById<T>(tableName: string, id: number): Promise<T | null> {
    try {
      const table = await this.dbService.getTable<T>(tableName);
      return await table.get(id); 
    } catch (error) {
      console.error(`Error retrieving data from table ${tableName} for ${id}`, error);
      return null;  
    }
  }

  async getTable<T>(tableName: string): Promise<Table<T>> {
    const table = this.dbService.getTable<T>(tableName);
    if (!table) {
      throw new Error(`Table "${tableName}" does not exist in the database.`);
    }
    return table;
  }

  async setCurrentProject(projectId: string): Promise<void> {
    await this.dbService.setCurrentProjectId(projectId);
  }

  async getCurrentProject(): Promise<string | null> {
    return await this.dbService.getCurrentProjectId();
  }

  async updateById<T>(tableName: string, id: number, item: T):Promise<void>{
    try {
      const table = await this.dbService.getTable<T>(tableName);
      const updatedItem = { ...item, id };
      await table.put(updatedItem, id);
    } catch (error) {
      console.error(`Error updating data in table ${tableName} for ${id}`, error);
    }
  }


  async deleteTable(tableName: string): Promise<void> {
    try {
      await this.dbService.deleteTable(tableName);
    } catch (error) {
      console.error(`Error deleting table ${tableName}:`, error);
      throw error;
    }
  }
  
}
